// @flow
import Monitoring from "./monitoring";
import Logger from "../common/logger";
import URLParamUtil from "../../util/url-param-util";
import OuterWidget from "./outer-widget";

"use strict";

export default class UzouGlobal {
  constructor(widgets: Array<OuterWidget>, monitoring: Monitoring, logger: Logger, isRehearsal: boolean) {
    this.widgets = widgets;
    this.monitoring = monitoring;
    this.logger = logger;
    this.isRehearsal = isRehearsal;
  }

  static getInstance(monitoring: Monitoring, logger: Logger, window: Window): UzouGlobal{
    const widgets = [];
    const isRehearsal = URLParamUtil.isRehearsal(window);
    const uzouGlobal = new UzouGlobal(widgets, monitoring, logger, isRehearsal);
    // singleton
    UzouGlobal.getInstance = function(): UzouGlobal {
      return uzouGlobal;
    };

    return uzouGlobal;
  }
}


// WEBPACK FOOTER //
// ./src/js/model/outer/uzou-global.js